export const CONDITIONAL_PROMPT_MAX_LENGTH = 5000 as const;
